<template lang="pug">
  div.added-options
    button.added-item(@click="clearItem(item)"
                       v-for="(item, i) in selectedFilters")
      span {{item.name}}
      i.icon.iconfont.icon-close
    button.clear-all(@click="clearAllItems", v-if="selectedFilters.length") 清除全部

</template>
<script>
export default {
  name: 'addedOption',
  props: {
    selectedFilters: {
      type: Array
    },
    clearItem: {
      type: Function
    },
    clearAllItems: {
      type: Function
    },
    specialName: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
.added-options {
  padding-left:0.625rem;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  border-left:0.0625rem solid #b7b7bf;
}
.added-option::before {
  padding-left:0.625rem;
  display: inline-block;
  content: '';
  height: 1.5rem;
  width: 1px;
  background: #b7b7bf;
  margin-right: 0.9375rem;
}
.added-item {
  background: transparent;
  color: #3b3b3f;
  font-size: 0.9em;
  padding: 0 1.25rem;
  margin:0 0.5rem;
  height: 2rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  transition: all 0.3s ease-in-out;
  border: none;
  &:hover {
    cursor: pointer;
  }
  .icon {
    margin-left: .625rem;
    font-size: 0.8rem;
  }
}
.added-items {
  background: transparent;
  color: #fff;
  font-size: 0.9em;
  padding: 0 1.23rem;
  margin:0 0.5rem;
  height: 2rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  background: #1a1a1a;
  transition: all 0.3s ease-in-out;
  border: none;
}

.clear-all {
  background: transparent;
  color: #0080a3;
  letter-spacing: .05em;
  font-size: .8125rem;
  white-space: nowrap;
  border: none;
  margin-left: 0.625rem;
  &:hover {
    cursor: pointer;
  }
}

</style>
